import {createContext} from "react";

const defaultValue = {
	users: {},
	connected: false,
	RoomID: undefined,
	StoreData: null,
	Actions: {
		Room: {
			create: () => {},
			join: (uuid: string) => {},
			leave: () => {},
			storeData: () => {}
		}
	}
}

export interface WebSocketContextType {
	users: Record<string, {id: string, name: string}[]>,
	connected: boolean,
	RoomID?: string,
	StoreData: any,
	Actions: {
		Room: {
			create: () => void,
			join: (uuid: string) => void,
			leave: () => void,
			storeData: (data: any) => void
		}
	}
}

export const WebSocketContext = createContext<WebSocketContextType>( defaultValue )